import Counter from "$components/Counter";
import * as React from 'react';
export default {
  Counter,
  React
};